import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import Landing from './pages/Landing';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import BuyerDashboard from './pages/buyer/BuyerDashboard';
import ListingDetail from './pages/buyer/ListingDetail';
import MapView from './pages/buyer/MapView';
import UpgradePage from './pages/UpgradePage';
import ComparePage from './pages/buyer/ComparePage';
import AgentDashboard from './pages/agent/AgentDashboard';
import SellerDashboard from './pages/seller/SellerDashboard';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProfileSettings from './pages/settings/ProfileSettings';

function getRoleHome(role) {
  if (role === 'buyer') return '/discover';
  if (role === 'agent') return '/agent';
  if (role === 'seller') return '/seller';
  return '/admin';
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-4 border-t-transparent animate-spin" style={{ borderColor: '#0A192F', borderTopColor: 'transparent' }} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={user ? <Navigate to={getRoleHome(user.role)} replace /> : <Login />} />
        <Route path="/register" element={user ? <Navigate to={getRoleHome(user.role)} replace /> : <Register />} />

        {/* Buyer routes */}
        <Route path="/discover" element={<ProtectedRoute role="buyer"><BuyerDashboard tab="discover" /></ProtectedRoute>} />
        <Route path="/saved" element={<ProtectedRoute role="buyer"><BuyerDashboard tab="saved" /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute role="buyer"><BuyerDashboard tab="profile" /></ProtectedRoute>} />
        <Route path="/listing/:id" element={<ProtectedRoute role="buyer"><ListingDetail /></ProtectedRoute>} />
        <Route path="/map" element={<ProtectedRoute role="buyer"><MapView /></ProtectedRoute>} />
        <Route path="/upgrade" element={<UpgradePage />} />
        <Route path="/compare" element={<ProtectedRoute role="buyer"><ComparePage /></ProtectedRoute>} />

        {/* Agent routes */}
        <Route path="/agent" element={<ProtectedRoute role="agent"><AgentDashboard tab="dashboard" /></ProtectedRoute>} />
        <Route path="/agent/listings" element={<ProtectedRoute role="agent"><AgentDashboard tab="listings" /></ProtectedRoute>} />
        <Route path="/agent/leads" element={<ProtectedRoute role="agent"><AgentDashboard tab="leads" /></ProtectedRoute>} />
        <Route path="/agent/prospects" element={<ProtectedRoute role="agent"><AgentDashboard tab="prospects" /></ProtectedRoute>} />

        {/* Seller routes */}
        <Route path="/seller" element={<ProtectedRoute role="seller"><SellerDashboard tab="dashboard" /></ProtectedRoute>} />
        <Route path="/seller/listings" element={<ProtectedRoute role="seller"><SellerDashboard tab="listings" /></ProtectedRoute>} />
        <Route path="/seller/leads" element={<ProtectedRoute role="seller"><SellerDashboard tab="leads" /></ProtectedRoute>} />

        {/* Admin routes */}
        <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />

        {/* Settings — all authenticated users */}
        <Route path="/settings" element={<ProtectedRoute><ProfileSettings /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
